var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null)
,		Throttly = require('throttly')
,   Onscroll = require('onscrolling');

/**
 * Initializes the Local Nav.
 * @constructor
 * @param {Object} el - The local nav element.
 * taken from Wanderlust
 */ 

	function LocalNav(el) {
  this.el = el;
  this.$el = $(el);

	//Button Scrolling Links
	this.$el.on('click', 'a[href^="#"]', function(e) {
	    e.preventDefault();

	    var target = this.hash;
	    var $target = $(target);
	    console.log(this.hash);

	    $(target).velocity('scroll', {
        duration: 500,
        offset: -60
      });
	});

  //Local sticky nav
	var $localNav = $('[data-sticky]').first()
		,   affixed = false
		,   dir     = 'down'
		,   scroll  = 0;	
	
	Onscroll(function(_scroll){
  if (_scroll > scroll){
    dir = 'down';
  } else {
    dir = 'up'
  }; 
  scroll = _scroll;
  toggleState();
	});

  function toggleState(e){
	  var offset = $(window).scrollTop();
	  if (offset >= 250 && !affixed){
	    $localNav.addClass('affix');
	    affixed = true;
		  } 
		else if (offset < 150 && affixed){
	    $localNav.removeClass('affix');
	    affixed = false;
		  }
		}
	}


module.exports = LocalNav;
